import React, {CSSProperties, FC, memo, useCallback, useEffect, useRef, useState} from "react";
import {Dropdown} from "react-bootstrap";
import {ContextMenuContainer, DropdownToggle} from "./ContextMenuStyle";
import {fetchDeleteFile, fetchUploadFile, fetchUploadFiles} from "../../fetch/FileRequest";
import {useDispatch} from "react-redux";
import {actions} from "../../store/sliceApp";
import {actions as modal} from "../../store/sliceModal";
import {IFile} from "../../store/sliceFiles";

type ContextMenuProps = {
    file: IFile
    children: React.ReactElement
    style?: CSSProperties | undefined;
    isPublic?: boolean
}

const ContextMenu: FC<ContextMenuProps> = (props) => {

    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()

    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    const ref = useRef<HTMLDivElement>(null)

    let timer: NodeJS.Timer | undefined;

    useEffect(() => {
            const check = (e: any) => {
                if (open && ref.current && !ref.current.contains(e.target)) {
                    setOpen(false)
                    if (timer) {
                        clearInterval(timer)
                    }
                }
            }

            document.addEventListener("mousedown", check)
            // document.addEventListener("touchend", check)
            return () => {
                document.removeEventListener("mousedown", check)
                // document.removeEventListener("touchend", check)
            }
        }
        ,[open])

    useEffect(() => {
        const handleMouseMove = (event: { clientX: any; clientY: any; }) => {
            if (!open) {
                setMousePos({x: event.clientX, y: event.clientY});
            }
        };
        window.addEventListener('mousemove', handleMouseMove);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    },[open]);


    const contextMenuHandle = useCallback( (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation()
        event.preventDefault()
        setOpen(true)
    },[])

    const onTouchStart = useCallback((event: React.TouchEvent<HTMLDivElement>) => {
        // @ts-ignore
        timer = setInterval(() => {
            setOpen(true)
            dispatch(actions.setContextBackground(true))
            clearInterval(timer)
        }, 800);
    }, [open, timer])

    const onTouchEnd = useCallback((event: React.TouchEvent<HTMLDivElement>) => {
        if (open) {
            event.stopPropagation()
            event.preventDefault()
        }
        clearInterval(timer)
    },[open, timer])

    const onTouchEndMenu = useCallback((event: React.TouchEvent<HTMLDivElement>) => {
        event.stopPropagation()
        event.preventDefault()
        clearInterval(timer)
        setOpen(false)
        dispatch(actions.setContextBackground(false))
    },[open, timer])

    const onClickCloseMenu = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation()
        event.preventDefault()
        setOpen(false)
    },[])


    const deleteMenuHandle = useCallback( (event: React.MouseEvent<HTMLDivElement>) => {
        if (props.file?.id) {
            fetchDeleteFile(props.file.id, props.file?.folder)
        }
    },[open])

    const deleteMenuTouchHandle = useCallback( (event: React.TouchEvent<HTMLDivElement>) => {
        if (props.file?.id) {
            fetchDeleteFile(props.file.id, props.file?.folder)
        }
    },[open])

    const renameMenuHandle = useCallback( (event: React.MouseEvent<HTMLDivElement>) => {
        dispatch(modal.showCreateRenameModal({title: "Переименовать", file: props.file, isRename: true}))
    },[open])

    const renameMenuTouchHandle = useCallback( (event: React.TouchEvent<HTMLDivElement>) => {
        dispatch(modal.showCreateRenameModal({ title: "Переименовать", file: props.file, isRename: true}))
    },[open])

    const moveMenuHandle = useCallback( (event: React.MouseEvent<HTMLDivElement>) => {
        dispatch(modal.showMoveModal({ title: "Перемещение файла", file: props.file}))
    },[open])
    const moveMenuTouchHandle = useCallback( (event: React.TouchEvent<HTMLDivElement>) => {
        dispatch(modal.showMoveModal({ title: "Перемещение файла", file: props.file}))
    },[open])

    const downloadMenuHandle = useCallback( (event: React.MouseEvent<HTMLDivElement>) => {
        if (props.file?.id) {
            if (props.file?.folder) {
                fetchUploadFile(props.file.id, `${props.file.name}.zip`)
            } else {
                fetchUploadFile(props.file.id, `${props.file.name}.${props.file.type}`)
            }
        }
    },[open])

    const downloadTouchMenuHandle = useCallback( (event: React.TouchEvent<HTMLDivElement>) => {
        if (props.file?.id) {
            if (props.file?.folder) {
                fetchUploadFile(props.file.id, `${props.file.name}.zip`)
            } else {
                fetchUploadFile(props.file.id, `${props.file.name}.${props.file.type}`)
            }
        }
    },[open])


    const accessHandle = useCallback( (event: React.MouseEvent<HTMLDivElement>) => {
        if (props.file?.id) {
            dispatch(modal.showAccessModal(props.file.id))
        }
    },[open])
    const accessTouchHandle = useCallback( (event: React.TouchEvent<HTMLDivElement>) => {
        if (props.file?.id) {
            dispatch(modal.showAccessModal(props.file.id))
        }
    },[open])

    return (
        <ContextMenuContainer style={props.style} onContextMenu={contextMenuHandle} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
            {props.children}
            <Dropdown show={open} ref={ref}  style={{height: 0, position: "absolute", left: `${mousePos.x}px`}}>
                <DropdownToggle/>
                <Dropdown.Menu onClick={onClickCloseMenu} onTouchEnd={onTouchEndMenu}>
                    <Dropdown.Item disabled={props.isPublic} onClick={deleteMenuHandle} onTouchEnd={deleteMenuTouchHandle}>Удалить</Dropdown.Item>
                    <Dropdown.Item disabled={props.isPublic} onClick={renameMenuHandle} onTouchEnd={renameMenuTouchHandle}>Переименовать</Dropdown.Item>
                    <Dropdown.Item disabled={props.isPublic} onClick={moveMenuHandle} onTouchEnd={moveMenuTouchHandle}>Перенести</Dropdown.Item>
                    <Dropdown.Item onClick={downloadMenuHandle} onTouchEnd={downloadTouchMenuHandle}>Скачать</Dropdown.Item>
                    <Dropdown.Item disabled={props.isPublic} onClick={accessHandle} onTouchEnd={accessTouchHandle}>Общий доступ</Dropdown.Item>

                </Dropdown.Menu>
            </Dropdown>
        </ContextMenuContainer>
    )
}

export default memo(ContextMenu)
